<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
import ExcelJS from "exceljs";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import {getBaseUrl} from "@/helpers/baseUrl";



export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,

  },
  data() {

    return {
      title: "Produtos",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Produtos",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,

      dtListPesqUsuario: null,
      showModalMsgUpdating: false
    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {
    recontarSaldos(){
      console.log('recontarSaldos')

      Swal.fire({
        position: "center",
        icon: "info",
        title: 'Recontando saldos!',
        showConfirmButton: false,
        showCancelButton: false,
        timer: 1500
      }).then(() => {
        this.showModalMsgUpdating = true

        api.get(`${getBaseUrl()}api/recontarsaldos`, {
        }).then((res) => {
          console.log('then axios');
          console.log(res.data);

          this.showModalMsgUpdating = false

          if(res.data.success){
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              showCancelButton: false,
              timer: 1500
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Erro na recontagem dos saldos!",
              showConfirmButton: false,
              showCancelButton: false,
              timer: 2500
            })
          }
        })
      })
    },

    exportRelatorioProdutos() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: 'Deseja agrupar todas as empresas no relatório?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((confirmed) => {
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: 'Gerando relatório',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          api.get(`${getBaseUrl()}api/exportrelprod`, {
            params: {
              geral: confirmed.isConfirmed
            }
          })
          .then((res) => {
            console.log('then axios');
            console.log(res.data);

            if (res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                console.log('then axios');
                console.log(res.data);

                let listForExcel = res.data.listProdutoModel;

                // Chamar a função para gerar o XLS
                this.exportToExcel(listForExcel, "relatorio_produtos.xlsx");
              });
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.error,
                showConfirmButton: false,
                timer: 1500
              });
            }
          });
        })
      })
    },

    exportToExcel(data, filename) {
  if (!data || data.length === 0) {
    console.error("Nenhum dado disponível para exportação.");
    return;
  }

  // Criar um novo workbook e uma planilha
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Relatório");

  // Adicionar cabeçalhos
  worksheet.columns = Object.keys(data[0]).map((key) => ({
    header: key,
    key: key,
    width: 20, // Ajuste conforme necessário
  }));

  // Adicionar linhas de dados
  data.forEach((row) => {
    worksheet.addRow(row);
  });

  // Criar o arquivo Excel em formato binário
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
},


    pesqUsuario(evt){
      console.log('pesqUsuario')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqUsuario = res.data
        });
      }
    },


    novoProduto(){
      console.log('novoProduto')
      const routeData = this.$router.resolve(`/produto/editar/0`)
      window.open(routeData.href, '_blank')


    },




    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Produtos'
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/produtos`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row)


      const routeData = this.$router.resolve(`/produto/editar/${row.data.id}`)
      window.open(routeData.href, '_blank')


    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status

          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        } else if (e.column.dataField === "stsicms") {
          // console.log('onCellPrepared')
          // console.log(e.data.stsicms)
          const valStatus = e.data.stsicms
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 1:
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 0:
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        } else if (e.column.dataField === "stspiscof") {
          // console.log('onCellPrepared')
          // console.log(e.data.stspiscof)
          const valStatus = e.data.stspiscof
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 1:
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 0:
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        } else if (e.column.dataField === 'formato') {
          const formato = e.data.formato
          
          let corStatus = 'rgba(78,59,0,0.5)'

          switch (formato) {
            case null:
            case "":
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 0:
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e) {
      console.log('onExporting');
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');

      exportDataGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ cell, gridCell }) => {
          if (!cell || !gridCell) return;

          if (gridCell.rowType === 'data') {
            if (typeof gridCell.value === 'number') {
              cell.value = gridCell.value.toString().replace('.', ',');
            } else if (typeof gridCell.value === 'string') {
              cell.value = gridCell.value.toString();
            }
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });

      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeCanal(e) {
      switch (e.value) {
        case 'PU':
          return 'Pusher'

      }
      return 'Não Definido'
    },

    nomeSimplesComposto(e){
      if(e.value === 'CO'){
        return 'Composto'
      }else{
        return 'Simples'
      }
    },

    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo (A)'
      } else {
        return 'Inativo (I)'
      }
    },

    nomeStatusImposto(e) {
      if (e.value === 1) {
        return 'Ativo (1)'
      } else {
        return 'Inativo (0)'
      }
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Novo Produto"
              :on-click="novoProduto"/>

        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="refresh"
              hint="Recontar saldos"
              text="Recontar saldos"
              :on-click="recontarSaldos"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="save"
              hint="Exportar relatório de Produtos"
              text="Relatório Geral"
              :on-click="exportRelatorioProdutos"/>
        </DxItem>
      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid">

          <!--Posteriormente reabilitar a possibilidade de export-->
          <!--@exporting="onExporting">--> 

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxSelection mode="single"/>

        <!--Posteriormente reativar a parte de exportação corretamente-->
        <DxExport
            :enabled="false"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strProdutosList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codigo"
            caption="Código"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codbarra"
            caption="Cód.Barras"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="descricao"
            caption="Descrição"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="formato"
            caption="Formato"
            data-type="text"
            alignment="left"
            :customize-text="nomeSimplesComposto"
            :filter-operations="['=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="unidade"
            caption="Unidade"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            caption="Status"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">


          <DxColumn
              data-field="status"
              caption="Status"
              alignment="left"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="stsicms"
              caption="ICMS"
              alignment="left"
              data-type="text"
              :customize-text="nomeStatusImposto"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="stspiscof"
              caption="PIS/COFINS"
              alignment="left"
              data-type="text"
              :customize-text="nomeStatusImposto"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="false"/>


        </DxColumn>




        <DxColumn
            data-field="preco"
            caption="Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldo"
            caption="Saldo Disponível"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldoprev"
            caption="Saldo Previsto"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldoreser"
            caption="Saldo Reservado"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldobloq"
            caption="Saldo Bloqueado"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldosaida"
            caption="Saldo Saídas"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldofalta"
            caption="Saldo Faltas"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldoavar"
            caption="Saldo Avarias"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="saldonegat"
            caption="Saldo Negativo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="custo"
            caption="Custo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>
    </div>


    <b-modal
        v-model="showModalMsgUpdating"
        id="showModalMsgUpdating"
        size="lg"
        hide-footer
    >
      <div>
        <h3 class="text-info text-center">Aguarde um momento, estamos processando os dados...</h3>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
